module.exports = __webpack_public_path__ + "static/media/kocka1IUG.e587e5e0.png";